import React from "react";

const AdminDashboardDayGrid = ({ day, allGameData, setDate, date, colIndex }) => {
  const filteredArray = allGameData.filter((o) => o.date === day);

  // Group by gameName and find the record with the minimum remainingTime for each unique game
  const uniqueGamesMap = {};
  filteredArray.forEach((record) => {
    const gameName = record.gameName || record.gameId;
    const currentMin = uniqueGamesMap[gameName];
    const recRemaining = record.remainingTime || 0;
    if (!currentMin || recRemaining < (currentMin.remainingTime || 0)) {
      uniqueGamesMap[gameName] = record;
    }
  });

  const uniqueGames = Object.values(uniqueGamesMap);

  const totalRemainingTime = uniqueGames.reduce((acc, cur) => {
    const remaining = cur.remainingTime || 0;
    // Treat remainingTime < 10 seconds as fully completed (0 seconds remaining)
    const effectiveRemaining = remaining < 10 ? 0 : remaining;
    return acc + effectiveRemaining;
  }, 0);

  const totalGameTime = uniqueGames.reduce((acc, cur) => {
    const isMatchGabor = cur?.gameId === "matchGabor" || cur?.gameName?.includes("Match Gabor");
    return acc + (isMatchGabor ? 600 : 300);
  }, 0);

  const playingTime = Math.max(0, totalGameTime - totalRemainingTime);

  const minutes = Math.floor(playingTime / 60);
  const seconds = String(playingTime % 60).padStart(2, "0");

  const opacity = Math.min(100, Math.ceil((playingTime / 3600) * 100)) + 10;

  const tooltipId = `tooltip-${day}`;

  let tooltipPositionClass = "left-1/2 -translate-x-1/2";
  let arrowPositionClass = "before:left-1/2 before:-ml-2";

  if (colIndex !== undefined) {
    if (colIndex < 10) {
      tooltipPositionClass = "left-0 translate-x-0";
      arrowPositionClass = "before:left-3 before:-ml-0";
    } else if (colIndex > 43) {
      tooltipPositionClass = "right-0 left-auto translate-x-0";
      arrowPositionClass = "before:right-3 before:left-auto before:-ml-0";
    }
  }

  return (
    <>
      {playingTime > 0 ? (
        <span
          className="relative overflow-hidden cursor-pointer group hover:overflow-visible focus-visible:outline-none"
          aria-describedby={tooltipId}
        >
          <div
            className={
              day === date
                ? "lg:min-h-[18px] md:min-h-[14px] min-h-[10px] bg-green-500"
                : "lg:min-h-[18px] md:min-h-[14px] min-h-[10px]"
            }
          >
            <div
              onClick={() => setDate(day)}
              style={{ opacity: `${opacity}%` }}
              className={
                day === date
                  ? "lg:min-h-[18px] md:min-h-[14px] min-h-[10px] bg-green-500 group-hover:border-2 border-primary"
                  : "lg:min-h-[18px] md:min-h-[14px] min-h-[10px] bg-secondary group-hover:border-2 border-primary"
              }
            />
          </div>
          <span
            role="tooltip"
            id={tooltipId}
            className={`invisible absolute bottom-full z-10 mb-2 rounded bg-primary p-4 text-sm text-white opacity-0 transition-all before:invisible before:absolute before:top-full before:z-10 before:mb-2 before:border-x-8 before:border-t-8 before:border-x-transparent before:border-t-blue-400 before:opacity-0 before:transition-all before:content-[''] group-hover:visible group-hover:block group-hover:opacity-100 group-hover:before:visible group-hover:before:opacity-100 ${tooltipPositionClass} ${arrowPositionClass}`}
          >
            <p className="whitespace-nowrap">
              {day} | Exercise Time: {minutes}:{seconds} min
            </p>
          </span>
        </span>
      ) : (
        <span
          className="relative overflow-hidden cursor-pointer group hover:overflow-visible focus-visible:outline-none"
          aria-describedby={tooltipId}
        >
          <div
            onClick={() => setDate(day)}
            className={
              day === date
                ? "lg:min-h-[18px] md:min-h-[14px] min-h-[10px] bg-green-500 group-hover:border-2 border-primary"
                : "lg:min-h-[18px] md:min-h-[14px] min-h-[10px] bg-gray-100 group-hover:border-2 border-primary"
            }
          />
          <span
            role="tooltip"
            id={tooltipId}
            className={`invisible absolute bottom-full z-10 mb-2 rounded bg-primary p-4 text-sm text-white opacity-0 transition-all before:invisible before:absolute before:top-full before:z-10 before:mb-2 before:border-x-8 before:border-t-8 before:border-x-transparent before:border-t-blue-400 before:opacity-0 before:transition-all before:content-[''] group-hover:visible group-hover:block group-hover:opacity-100 group-hover:before:visible group-hover:before:opacity-100 ${tooltipPositionClass} ${arrowPositionClass}`}
          >
            <p className="whitespace-nowrap">{day} | No activity</p>
          </span>
        </span>
      )}
    </>
  );
};

export default AdminDashboardDayGrid;
